/* חיצי הרצועה של "מידע וטיפים מהמומחים שלנו".
 *
 * בלי ספרייה: הקרוסלה של הספק (.nov-slick-carousel ב-js-global.js) היא Slick
 * על jQuery, והיא דורשת את מבנה ה-DOM והמחלקות שלה. כאן הגלילה היא
 * scroll-snap של הדפדפן, והקובץ הזה רק מזיז אותה ומכבה חיצים בקצוות —
 * כך שאם הוא לא נטען כלל, הרצועה עדיין נגררת באצבע ובמקלדת. */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-jm-expert-tips]';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function stepSize(track) {
    var card = track.firstElementChild;
    if (!card) return track.clientWidth;
    var gap = parseFloat(window.getComputedStyle(track).columnGap);
    if (isNaN(gap)) gap = 0;
    return Math.round(card.getBoundingClientRect().width + gap);
  }

  function init(root) {
    if (root.getAttribute('data-jm-expert-tips-ready') === 'true') return;

    var track = root.querySelector('[data-jm-expert-tips-track]');
    var prev = root.querySelector('[data-jm-expert-tips-prev]');
    var next = root.querySelector('[data-jm-expert-tips-next]');
    if (!track || !prev || !next) return;

    root.setAttribute('data-jm-expert-tips-ready', 'true');

    function sync() {
      var max = track.scrollWidth - track.clientWidth;

      /* סימנים ב-RTL, החלק שכבר הפיל את הרכיב הקודם בתבנית הזאת:
       * scrollLeft נמדד מהקצה השמאלי הפיזי, ולכן בעמוד ימין-לשמאל הוא 0
       * בתחילת הרצועה (הקצה הימני) ויורד עד max- בסופה. Math.abs מחזיר
       * אותו למרחק חיובי מנקודת ההתחלה, וכך אותה בדיקה נכונה גם במנוע
       * שמדווח בסימן חיובי. הסטייה של פיקסל היא עיגול תת-פיקסלי של
       * הדפדפן — בלעדיה כפתור "הבא" לא מגיע למצב כבוי בסוף הרצועה. */
      var scrolled = Math.abs(track.scrollLeft);

      prev.disabled = scrolled <= 1;
      next.disabled = scrolled >= max - 1;
      root.classList.toggle('jm-expert-tips--static', max <= 1);
    }

    /* direction: 1 = הקודם (ימינה בעברית), 1- = הבא (שמאלה).
     * scrollBy מקבל left בפיקסלים פיזיים והוא אינו מתהפך ב-RTL, ולכן
     * הכיוון נקבע כאן במפורש ולא מתוך ההנחה ש"הבא = חיובי". */
    function move(direction) {
      track.scrollBy({
        left: direction * stepSize(track),
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });
    }

    prev.addEventListener('click', function () { move(1); });
    next.addEventListener('click', function () { move(-1); });
    track.addEventListener('scroll', sync, { passive: true });

    if (window.ResizeObserver) {
      new ResizeObserver(sync).observe(track);
    } else {
      window.addEventListener('resize', sync);
    }

    sync();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* עורך התבניות מחליף את ה-DOM של הסקשן בלי לטעון מחדש את העמוד, והסימון
   * החדש מגיע בלי מאזינים. data-jm-expert-tips-ready יושב על האלמנט עצמו
   * ולכן הוא נעלם יחד איתו, ואין כאן רישום כפול. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
